export default __webpack_public_path__ + "static/media/tmdb.de1a664e.svg";